<template>
  <div>
    <v-data-table
      v-model="selected"
      :items="items"
      disable-initial-sort
      :headers="filteredHeaders"
      :loading="isLoading"
      item-key="family_to_accept_id"
      hide-actions
      select-all
      :headers-length="filteredHeaders.length + 2"
    >
      <template
        slot="headers"
        slot-scope="props"
      >
        <tr>
          <th class="pa-0" />
          <template v-for="header in props.headers">
            <th
              v-if="desktopOnly && header.mobileOnly !== true"
              :key="header.text"
              class="text-xs-left"
            >
              {{ header.text }}
              <a @click="sorting()">
                <BaseIcon
                  v-if="header.icon"
                  width="16px"
                  height="13px"
                >
                  <component :is="header.icon" />
                </BaseIcon>
              </a>
            </th>
          </template>
          <template v-for="header in props.headers">
            <th
              v-if="!header.desktopOnly && !desktopOnly"
              :key="header.text"
              class="text-xs-left"
            >
              {{ header.text }}
              <a @click="sorting()">
                <BaseIcon
                  v-if="header.icon"
                  width="16px"
                  height="13px"
                >
                  <component :is="header.icon" />
                </BaseIcon>
              </a>
            </th>
          </template>
        </tr>
      </template>
      <template
        slot="items"
        slot-scope="props"
      >
        <tr
          :style="[
            { 'background-color': canVerifyConsent(props.item) ? 'rgba(253,232,233,0.5)' : '#fff' }
          ]"
        >
          <td class="pa-0">
            <div
              class="new-item-border"
              :class="{ 'd-none': true }"
            />
          </td>

          <td v-if="desktopOnly">
            {{ props.item.family_to_accept_id }}
          </td>

          <td
            :class="[
              { 'fw-600': $vuetify.breakpoint.smAndUp },
              { 'py-1 pr-0': $vuetify.breakpoint.xsOnly }
            ]"
          >
            {{ fullName(props.item) }}
            <div
              v-if="!desktopOnly"
              class="text-truncate"
            >
              <p class="ma-0">
                {{ fullStreet(props.item) }}
              </p>
              <p class="ma-0">
                {{ fullCity(props.item) }}
              </p>
            </div>
          </td>

          <td v-show="desktopOnly">
            <p class="ma-0">
              {{ fullStreet(props.item) }}
            </p>
            <p class="ma-0">
              {{ fullCity(props.item) }}
            </p>
          </td>

          <td
            v-show="desktopOnly"
            class="clickable"
          >
            <v-layout>
              <v-flex
                v-for="(consent, index) in props?.item?.initial_consent_files"
                :key="index"
                @click.prevent="openConsentFile(props?.item?.family_to_accept_id, consent)"
              >
                <BaseIcon>
                  <PdfIcon />
                </BaseIcon>
              </v-flex>
            </v-layout>
          </td>

          <td v-if="desktopOnly">
            <p
              v-if="props?.item?.reporter != null"
              class="mb-0"
            >
              {{ props.item.reporter?.email }}
            </p>
          </td>

          <td v-if="desktopOnly">
            <p class="mb-0">
              {{ formatDate(props.item?.created_at, { useIntl: true}) }}
            </p>
          </td>

          <td v-if="!desktopOnly">
            <v-layout>
              <v-flex>
                <v-layout wrap>
                  <v-layout>
                    <v-flex
                      v-for="(consent, index) in props?.item?.initial_consent_files"
                      :key="index"
                      @click.prevent="openConsentFile(props?.item?.family_to_accept_id, consent)"
                    >
                      <BaseIcon>
                        <PdfIcon />
                      </BaseIcon>
                    </v-flex>
                  </v-layout>
                  <v-flex xs12>
                    <div
                      :class="
                        props?.item?.initial_consent_files?.length > 0
                          ? 'reporter-email'
                          : 'no-consent-email'
                      "
                    >
                      <span v-if="props?.item?.reporter != null">{{
                        props.item.reporter?.email
                      }}</span>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </td>

          <td class="pl-1">
            <div>
              <v-layout
                v-if="canAcceptFamily(props.item)"
                class="text-xs-center"
              >
                <v-flex
                  v-if="acceptLoaders[props.item.family_to_accept_id]"
                  class="mr-3"
                  sm6
                >
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  />
                </v-flex>
                <v-flex
                  v-else
                  class="mr-3"
                  sm6
                  @click="acceptFamily(props.item)"
                >
                  <v-layout class="pa-2 clickable">
                    <v-flex shrink>
                      <div class="fab-button bg_green">
                        <v-icon
                          color="#00BB62"
                          small
                        >
                          check
                        </v-icon>
                      </div>
                    </v-flex>
                    <v-flex
                      shrink
                      class="fab-link"
                    >
                      <a>{{ $t('buttons.accept') }}</a>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  v-if="rejectLoaders[props.item.family_to_accept_id]"
                  class="mr-3"
                  sm6
                >
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  />
                </v-flex>
                <v-flex
                  v-else
                  sm6
                  @click="rejectAction(props.item.family_to_accept_id)"
                >
                  <v-layout class="pa-2 clickable">
                    <v-flex shrink>
                      <div class="fab-button bg_red">
                        <BaseIcon
                          color="#ED1C24"
                          width="10"
                          height="10"
                        >
                          <CloseIcon />
                        </BaseIcon>
                      </div>
                    </v-flex>
                    <v-flex
                      shrink
                      class="fab-link"
                    >
                      <a>{{ $t('buttons.reject') }}</a>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </td>
        </tr>
      </template>
      <template slot="no-data">
        <tr>
          <td colspan="10">
            <p
              v-show="!isLoading"
              class="text-xs-center pt-3"
            >
              {{ $t('message.error_families_list_empty') }}
            </p>
          </td>
        </tr>
      </template>
    </v-data-table>
    <LocationDialog
      :value="locationDialog"
      :loader="locationDialogLoader"
      @closeDialog="finishLocationDialog()"
      @acceptRejon="
        assignAndAccept(
          acceptedFamilyId,
          isExternal(acceptedFamilyId),
          isFTAHasWioStruct(acceptedFamilyId)
        )
      "
      @addWithoutRejon="addWithoutRejon"
    />
    <AssignLocationDialog
      :value="assignLocation"
      :description="assignLocationDescription"
      :loader="assignLocationDialogLoader"
      @cancel="assignLocation = false"
      @close="assignLocation = false"
      @assign="
        assignAndAccept(
          acceptedFamilyId,
          isExternal(acceptedFamilyId),
          isFTAHasWioStruct(acceptedFamilyId),
          $event
        )
      "
    />
    <FamilySimilarityCheck
      ref="FamilySimilarityCheck"
      :loader-for-similar="loaderForSimilar"
      :duplicate-router-return-name="'families-to-approval'"
      :add-family-callback="acceptAction"
      :for-decision-callback="forDecisionActions"
      :overwrite-family-edition-callback="overwriteFamilyEdition"
      :redirect-callback="overwriteActions"
      @finish="finishAllLocationsDialog()"
      @duplicateFound="rejectFamily(acceptedFamilyId)"
    />
    <CustomContextMenu
      :visible="contextData.visible"
      :event="contextData.event"
      :link-name="contextData.linkName"
      :id-param="contextData.id"
      @show="toggleContextMenu()"
    />

    <AppModal
      :visible="confirmationDialog"
      @close="confirmationDialogParameters.closeAction"
    >
      <template #title>
        <v-layout
          v-if="confirmationDialogParameters.title"
          align-center
        >
          <v-icon
            :color="confirmationDialogParameters.iconColor"
            pr-5
            mr-5
            large
          >
            {{ confirmationDialogParameters.icon }}
          </v-icon>
          <h2 class="display-3 display-3_dark ml-3">
            {{ confirmationDialogParameters.title }}
          </h2>
        </v-layout>
      </template>
      <template #content>
        <v-layout align-center>
          <v-icon
            v-if="!confirmationDialogParameters.title"
            :color="confirmationDialogParameters.iconColor"
            pr-5
            mr-5
            large
          >
            {{ confirmationDialogParameters.icon }}
          </v-icon>
          <p class="text-xs-left f-16 sz_grafit--text ma-0 mt-1 ml-2 font-weight-regular">
            {{ confirmationDialogParameters.content }}
          </p>
        </v-layout>
      </template>
      <template #actions>
        <v-layout justify-end>
          <v-btn
            color="sz_violet"
            @click="confirmationDialogParameters.action"
          >
            {{ $t('buttons.ok') }}
          </v-btn>
        </v-layout>
      </template>
    </AppModal>
    <v-snackbar
      v-model="showConfirmation"
      :timeout="5000"
      top
      class="confirmation"
      style="bottom: 0"
    >
      <p class="my-2 text-xs-center green--text">
        <v-icon color="green">
          check
        </v-icon>
        {{ $t('families_to_accept.consent_confirmation') }}
      </p>
    </v-snackbar>
    <AppModal
      :visible="isGluedModal"
      :close-button="false"
      persistent
    >
      <template slot="content">
        <v-layout
          align-center
          mt-3
        >
          <v-flex
            shrink
            pa-2
            pl-0
          >
            <v-icon color="sz_red">
              warning
            </v-icon>
          </v-flex>
          <v-flex
            shrink
            pa-2
            pr-0
          >
            <h2 class="text-xs-left f-16 sz_grafit--text ma-0 mt-1 font-weight-regular">
              {{ $t('alikes_families.p_e.glued_warning.title') }}
            </h2>
            <h2 class="text-xs-left f-16 sz_grafit--text ma-0 mt-2 font-weight-regular">
              {{ $t('alikes_families.p_e.glued_warning.text') }}
            </h2>
          </v-flex>
        </v-layout>
      </template>
      <template slot="actions">
        <v-layout
          align-center
          class="my-2"
          :justify-center="$vuetify.breakpoint.smAndDown"
          justify-end
        >
          <v-btn
            color="sz_violet"
            @click="closeGluedModal()"
          >
            {{ $t('buttons.ok') }}
          </v-btn>
        </v-layout>
      </template>
    </AppModal>
  </div>
</template>

<script>
import LocationDialog from '@/components/addFamily/internal/LocationDialog';
import AssignLocationDialog from '@/components/addFamily/manageLocation/AssignLocationDialog';
import CustomContextMenu from '@/components/widgets/CustomContextMenu';
import PhoneNumbersList from '@/components/widgets/PhoneNumbersList';
import FamilySimilarityCheck from '@/components/widgets/addFamily/FamilySimilarityCheck';
import refuseReasonDialog from '@/components/widgets/dataTable/refuseReasonDialog';
import filters from '@/constants/filters';
import permissions from '@/constants/permissions';
import BaseIcon from '@/icons/BaseIcon';
import ChangeIcon from '@/icons/ChangeIcon';
import CloseIcon from '@/icons/CloseIcon';
import PdfIcon from '@/icons/PdfIcon';
import PlusIcon from '@/icons/PlusIcon';
import SortIcon from '@/icons/SortIcon';
import SortIconRevert from '@/icons/SortIconRevert';
import consent from '@/mixins/consent';
import { formatDate } from '@/utils/formatDate';
import httpStatusCode from 'http-status-codes';
import isArray from 'lodash.isarray';
import ActionMenu from '../dataTable/ActionMenu';
import FamilyStatus from '../dataTable/FamilyStatus';
import AppModal from '@/components/widgets/AppModal.vue';

// @ToDo: refactor: add ts, fix responsibility, simplify breakpoint logic, v-for for custom td etc.
export default {
    name: 'ToAcceptFamiliesTable',
    components: {
        CustomContextMenu,
        PdfIcon,
        PlusIcon,
        CloseIcon,
        FamilyStatus,
        ActionMenu,
        PhoneNumbersList,
        BaseIcon,
        ChangeIcon,
        SortIcon,
        refuseReasonDialog,
        SortIconRevert,
        LocationDialog,
        AssignLocationDialog,
        AppModal,
        FamilySimilarityCheck
    },
    filters: {
        ...filters
    },
    mixins: [consent],
    props: ['items', 'headers', 'isLoading'],
    data () {
        return {
            permissions,
            httpStatusCode,
            selected: [],
            menuItems: [
                { id: 1, text: this.$t('families_to_accept.tooltip.add') },
                { id: 2, text: this.$t('families_to_accept.tooltip.remove') }
            ],
            isManageVolunteers: false,
            isRefuseFamily: false,
            selectedItem: null,
            selectedReason: null,
            showDialog: false,
            contextData: {
                visible: false,
                event: null,
                linkName: 'pending-family-card',
                id: null
            },
            sortingDirection: null,
            locationDialog: false,
            acceptedFamilyId: null,
            assignLocation: false,
            showConfirmation: false,
            confirmationDialog: false,
            assignLocationDescription: '',
            confirmationDialogParameters: {
                icon: '',
                iconColor: '',
                title: '',
                content: '',
                action: () => {},
                closeAction: () => {}
            },
            hasInternalAcceptPermission: false,
            locationDialogLoader: false,
            assignLocationDialogLoader: false,
            loaderForSimilar: false,
            acceptLoaders: {},
            rejectLoaders: {},
            isGluedModal: false
        };
    },
    computed: {
        desktopOnly () {
            return this.$vuetify.breakpoint.smAndUp;
        },
        filteredHeaders () {
            if (this.desktopOnly) {
                return this.headers;
            }
            return this.headers
                .filter((el) => {
                    return el.desktopOnly === false;
                })
                .sort((a, b) => {
                    if (b.text === 'ID' && a.text === this.$t('label.family')) {
                        return -1;
                    }
                    return 1;
                });
        },
        location () {
            return this.$store.getters['familyData/getLocation'];
        }
    },
    watch: {
        items: {
            handler (val) {
                if (isArray(val)) {
                    val.forEach((el) => {
                        this.$set(this.acceptLoaders, `${el.family_to_accept_id}`, false);
                        this.$set(this.rejectLoaders, `${el.family_to_accept_id}`, false);
                    });
                }
            },
            immediate: true
        }
    },
    created () {
        this.$store
            .dispatch('auth/hasPermission', this.permissions.FAMILY_TO_ACCEPT_INTERNAL)
            .then((res) => {
                this.hasInternalAcceptPermission = res;
            });
    },
    methods: {
        formatDate,
        fullName (item) {
            const _firstName = item.first_name !== null ? item.first_name : '';
            return _firstName + ' ' + item.last_name;
        },
        fullStreet (item) {
            const street = item.street ? item.street : '';
            const _flat = item.flat_number !== null ? '/' + item.flat_number : '';
            return street + ' ' + item.building_number + _flat;
        },
        fullCity (item) {
            return this.$options.filters.postalCode(item.postal_code) + ' ' + item.city;
        },
        isExternal (id) {
            return this.items.find((el) => el.family_to_accept_id === id).internal == null;
        },
        isFTAHasWioStruct (id) {
            return this.items.find((el) => el.family_to_accept_id === id).wio_struct_location_id !== null;
        },
        finishLocationDialog () {
            this.locationDialog = false;
            this.locationDialogLoader = false;
        },
        finishAllLocationsDialog () {
            this.locationDialog = false;
            this.locationDialogLoader = false;
            this.assignLocation = false;
            this.assignLocationDialogLoader = false;
        },
        searchRejon (item) {
            this.acceptedFamilyId = item.family_to_accept_id;
            const payload = {
                buildingNumber: item.building_number,
                city: item.city,
                provinceId: item.province.province_id
            };
            if (item.street != null) {
                payload.street = item.street;
            }
            return this.$store
                .dispatch('familyData/getLocation', payload, false)
                .then((data) => {
                    const status = data.response && data.response.status;
                    if (status === this.httpStatusCode.BAD_REQUEST) {
                        this.assignLocationDescription = this.$t(
                            'message.assign_location.description_without_rejon'
                        );
                        this.locationDialog = false;
                        this.assignLocation = true;
                    } else {
                        this.assignLocationDescription = this.$t(
                            'message.assign_location.description_with_rejon'
                        );
                        this.locationDialog = true;
                    }
                })
                .finally(() => {
                    this.acceptLoaders[item.family_to_accept_id] = false;
                });
        },
        acceptAction () {
            this.loaderForSimilar = true;
            return this.$store
                .dispatch('familyData/convertToFamily', this.acceptedFamilyId)
                .then(({ data }) => {
                    this.isGluedModal = !!data.data.is_glued;
                    this.confirmationDialogParameters = {
                        icon: 'check_circle_outline',
                        iconColor: 'green',
                        title: this.$t('families_to_accept.confirmation.title'),
                        content: this.$t('families_to_accept.confirmation.description'),
                        action: this.reloadTables,
                        closeAction: () => {
                            this.confirmationDialog = false;
                        }
                    };
                    this.confirmationDialog = !this.isGluedModal;
                    this.acceptedFamilyId = null;
                })
                .finally(() => {
                    this.loaderForSimilar = false;
                });
        },
        reloadTables () {
            this.confirmationDialog = false;
            this.$emit('reload-families-to-accept');
            this.$emit('reload-no-volunteer-families');
        },
        assignAndAccept (id, external, isFTAHasWioStruct, rejon = false) {
            this.locationDialogLoader = true;

            if (!external && isFTAHasWioStruct && !rejon) {
                this.$refs.FamilySimilarityCheck.init();
            } else {
                this.assignLocationDialogLoader = true;
                let wioStructLocationId;

                if (rejon) {
                    wioStructLocationId = rejon;
                } else if (this.location && ((!external && !isFTAHasWioStruct) || (external && !rejon))) {
                    wioStructLocationId = this.location.node.id;
                }

                const _data = {
                    FamilyToAcceptId: this.acceptedFamilyId,
                    wioStructLocationId
                };
                this.$store.dispatch('familyData/assignLocation', _data).then((data) => {
                    let name = '';
                    if (this.location) {
                        name = this.location.node.name;
                    }
                    this.$store.commit('familyData/setLocation', {
                        node: { id: data.data.wio_struct_location_id, name },
                        native: true
                    });
                    this.$refs.FamilySimilarityCheck.init();
                });
            }
        },
        canVerifyConsent (item) {
            return item.verified_initial_consent == null && item.internal !== true;
        },
        verifiedConsent (id) {
            this.$store
                .dispatch('familiesToAccept/verifiedConsent', id)
                .then(() => {
                    this.showConfirmation = true;
                    setTimeout(() => {
                        this.$emit('verify-consent', id);
                    }, 5000);
                })
                .finally(() => {
                    this.acceptLoaders[id] = false;
                });
        },
        clearParametersForCheckingSimilar () {
            this.$store.commit('familyData/clearFormData');
            this.$store.commit('familyData/setSimilarityParameters', null);
            this.$store.commit('familyData/setLocation', null);
        },
        forDecisionActions () {
            this.confirmationDialogParameters = {
                icon: 'warning',
                iconColor: 'red',
                title: this.$t('families_to_accept.for_decision_confirmation.title'),
                content: this.$t('families_to_accept.for_decision_confirmation.description'),
                action: () => {
                    this.confirmationDialog = false;
                },
                closeAction: () => {
                    this.confirmationDialog = false;
                }
            };
            this.confirmationDialog = true;
            this.acceptedFamilyId = null;
            this.clearParametersForCheckingSimilar();
        },
        overwriteFamilyEdition () {
            return this.$store.dispatch('familyData/overwriteFamilyData');
        },
        overwriteActions () {
            this.confirmationDialogParameters = {
                icon: 'check_circle_outline',
                iconColor: 'green',
                content: this.$t('families_to_accept.overwrite_confirmation.title'),
                action: () => {
                    this.confirmationDialog = false;
                },
                closeAction: () => {
                    this.rejectFamily(this.acceptedFamilyId);
                    this.confirmationDialog = false;
                    this.clearParametersForCheckingSimilar();
                }
            };
            this.confirmationDialog = true;
        },
        acceptFamily (item) {
            this.acceptLoaders[item.family_to_accept_id] = true;
            if (this.canVerifyConsent(item)) {
                this.verifiedConsent(item.family_to_accept_id);
            } else {
                this.clearParametersForCheckingSimilar();
                this.searchRejon(item).then(() => {
                    this.$store.commit('familyData/assignFamilyData', item);
                });
            }
        },
        addWithoutRejon () {
            this.assignLocation = true;
        },
        rejectAction (familyId) {
            this.rejectLoaders[familyId] = true;
            this.rejectFamily(familyId).finally(() => {
                this.rejectLoaders[familyId] = false;
            });
        },
        rejectFamily (familyId) {
            return this.$store.dispatch('familiesToAccept/removeFamilyToAccept', familyId).then(() => {
                this.$emit('reload-families-to-accept');
                this.acceptedFamilyId = null;
            });
        },
        openContext (id, $event) {
            this.contextData.id = id;
            if (
                $event.target.localName === 'td' ||
        $event.target.localName === 'p' ||
        $event.target.localName === 'span'
            ) {
                this.contextData.visible = true;
                this.contextData.event = $event;
            }
        },
        toggleContextMenu (val) {
            this.contextData.visible = val;
        },
        sorting () {
            this.sortingDirection =
        this.sortingDirection === 'desc' || this.sortingDirection === null ? 'asc' : 'desc';
            this.$emit('sorting', this.sortingDirection);
        },
        canAcceptFamily (item) {
            if (this.canVerifyConsent(item)) {
                return true;
            } else {
                return this.hasInternalAcceptPermission;
            }
        },
        closeGluedModal () {
            this.isGluedModal = false;
            this.confirmationDialog = true;
        }
    }
};
</script>

<style lang="scss" scoped>
.reporter-email {
  max-width: 170px;

  span {
    overflow: scroll;
    white-space: nowrap;
    max-width: 170px;
    display: block;

    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;
  }
}

.no-consent-email {
  max-width: 170px;

  span {
    overflow: scroll;
    word-break: break-word;
    white-space: normal;
    max-width: 170px;
    display: block;
  }
}
</style>
